import { EnumUserRelationshipsType } from 'lib/graphql';

import { CutsheetInfo, Job } from '../../../shared/split-slot/types';

export interface ReminderContext {
  processorHasCutsheetNeeded: boolean;
  vendorId: string | undefined | null;
  producerId: string | undefined | null;
}

export function slotCanSendReminder(
  slotInfo: CutsheetInfo | null,
  ctx: ReminderContext,
): boolean {
  if (!slotInfo?.contactUser) return false;
  if (!ctx.processorHasCutsheetNeeded) return false;

  const cu = slotInfo.contactUser;

  // Buyer must have email or phone
  if (!cu.email && !cu.phone) return false;

  // Cutsheet must be incomplete
  if (slotInfo.cutsheet?.name && slotInfo.locked) return false;

  // Buyer must have buyer relationship to this vendor and producer
  const hasBuyerRelationship = cu.relationships?.some(
    (r) =>
      r?.type === EnumUserRelationshipsType.Buyer &&
      r?.vendorId === ctx.vendorId &&
      r?.producerId === ctx.producerId,
  );
  if (!hasBuyerRelationship) return false;

  return true;
}

export function getReminderSentTo(
  slotInfo: CutsheetInfo | null,
  notificationHistory: Job['notificationHistory'],
): string | null {
  if (!slotInfo?.contactUser?._id) return null;
  const notification = notificationHistory?.find(
    (n) =>
      n?.type === 'addCutsheets' && n?.user?._id === slotInfo.contactUser?._id,
  );
  return notification?.sentTo ?? null;
}
